import PropTypes from 'prop-types';
import React from 'react';
import { useCartCount } from 'gatsby-theme-shopify-manager';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { AnimatePresence, motion } from 'framer-motion';
import { nanoid } from 'nanoid';

import { Link } from 'gatsby';
import { Logo, BagIcon } from './vectors';
import { mainNavigation } from '../data';

const transition = { min: 0, max: 100, bounceDamping: 9 };

function MobileMenu({ isOpen, setIsOpen }) {
  const cartCount = useCartCount();

  const close = () => setIsOpen(false);

  const MotionDialogOverlay = motion.custom(DialogOverlay);
  const MotionDialogContent = motion.custom(DialogContent);

  return (
    <AnimatePresence>
      {isOpen && (
        <MotionDialogOverlay
          onDismiss={close}
          initial="closed"
          animate="open"
          exit="closed"
          variants={{ open: { opacity: 1 }, closed: { opacity: 0 } }}
          transition={transition}
          className="fixed inset-0 z-40"
        >
          <div className="fixed inset-0 z-40 flex justify-end bg-black bg-opacity-50">
            <MotionDialogContent
              aria-label="Sidebar"
              initial="closed"
              animate="open"
              exit="closed"
              variants={{ open: { x: 0 }, closed: { x: '100%' } }}
              transition={transition}
              className="relative flex flex-col flex-1 w-full max-w-xs pt-2 pb-4 bg-white text-dark-pink focus:outline-none"
            >
              <div aria-hidden className="flex-shrink-0 w-14">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
              <div className="absolute top-0 left-0 p-1 -ml-14">
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  aria-label="Close sidebar"
                  className="flex items-center justify-center w-12 h-12 rounded-full focus:outline-none focus:bg-dark-pink"
                >
                  <svg
                    className="w-6 h-6 text-white"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="flex items-center justify-between flex-shrink-0 px-4">
                <Link
                  to="/"
                  className="p-2 transition duration-150 ease-in-out rounded focus:shadow-none focus:bg-gray-100"
                >
                  <Logo className="w-auto h-10 fill-current" />
                </Link>
                <Link
                  to="/cart/"
                  className="relative p-2 transition duration-150 ease-in-out rounded focus:shadow-none focus:bg-gray-100"
                >
                  <BagIcon className="w-6" />
                  <div className="absolute inset-0 flex items-center justify-center text-xs transform translate-y-0.5 tabular-nums">
                    {cartCount}
                  </div>
                </Link>
              </div>
              <div className="flex-1 h-0 mt-5 overflow-y-auto">
                <nav className="px-2 text-dark-pink">
                  {mainNavigation.collections.map((node) => (
                    <Link
                      key={nanoid()}
                      to={node.slug}
                      activeClassName="flex items-center px-2 py-2 text-white transition duration-150 ease-in-out bg-light-pink rounded-md group focus:bg-dark-pink"
                      className="flex items-center px-2 py-2 mt-1 transition duration-150 ease-in-out rounded-md group hover:text-white hover:bg-light-pink focus:text-white focus:bg-light-pink"
                    >
                      {node.label}
                    </Link>
                  ))}
                </nav>
              </div>
            </MotionDialogContent>
          </div>
        </MotionDialogOverlay>
      )}
    </AnimatePresence>
  );
}

MobileMenu.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
};

export { MobileMenu };
